import { Tag, Typography } from "antd";
import { dateFormat } from "../../../core/utils/date-utils";
import EnumHelper from "../../../enums/EnumHelper";
import StudyTypeEnum from "../../../enums/StudyTypeEnum";
import { billingStatusColor, billingStatusKey } from "../../../enums/ReportBillingStatusEnum";

const ellipsis = (width) => (text) => (
    <Typography.Text ellipsis={{ tooltip: text }} style={{ width }}>
        {text || '-'}
    </Typography.Text>
);

/**
 * Faturalandırma grid'inin kolonları.
 *
 * columnName = SIRALAMA için entity üzerindeki özellik yolu (sunucu bu yolu doğrudan ifadeye
 * çeviriyor). Faturalandırma durumunun rapor entity'sinde bir karşılığı yok — ayrı tabloda tutuluyor
 * ve LEFT JOIN ile geliyor — bu yüzden o kolon sıralanabilir DEĞİL.
 */
export default function reportBillingColumns(t) {
    return [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            columnName: 'id',
            sorter: true,
            width: 90,
        },
        {
            title: t('Billing Status'),
            dataIndex: 'billingStatus',
            key: 'billingStatus',
            width: 140,
            render: (text) => <Tag color={billingStatusColor(text)}>{t(billingStatusKey(text))}</Tag>
        },
        {
            title: t('Report Date'),
            dataIndex: 'reportDate',
            key: 'reportDate',
            columnName: 'createdDate',
            sorter: true,
            width: 120,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Confirm Date'),
            dataIndex: 'confirmDate',
            key: 'confirmDate',
            columnName: 'confirmDate',
            sorter: true,
            width: 120,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Patient Id'),
            dataIndex: 'dicomPatientId',
            key: 'dicomPatientId',
            columnName: 'request.study.patient.dicomPatientId',
            sorter: true,
            width: 110,
            render: ellipsis(110)
        },
        {
            title: t('Patient'),
            dataIndex: 'patientName',
            key: 'patientName',
            columnName: 'request.study.patient.name',
            sorter: true,
            width: 140,
            render: ellipsis(140)
        },
        {
            title: t('Hospital'),
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            columnName: 'request.study.pacsSystem.hospital.name',
            sorter: true,
            width: 120,
            render: ellipsis(120)
        },
        {
            title: t('Request Name'),
            dataIndex: 'requestName',
            key: 'requestName',
            columnName: 'request.requestType.displayName',
            sorter: true,
            width: 170,
            render: ellipsis(170)
        },
        {
            title: t('Accession No'),
            dataIndex: 'accessionNumber',
            key: 'accessionNumber',
            columnName: 'request.accessionNumber',
            sorter: true,
            width: 130,
            render: ellipsis(130)
        },
        {
            title: t('SUT Code'),
            dataIndex: 'sutCode',
            key: 'sutCode',
            columnName: 'request.requestType.sutCode',
            sorter: true,
            width: 100,
            render: ellipsis(100)
        },
        {
            title: t('Modality'),
            dataIndex: 'modality',
            key: 'modality',
            columnName: 'request.study.modality.name',
            sorter: true,
            width: 80,
        },
        {
            title: t('Study Date'),
            dataIndex: 'studyDate',
            key: 'studyDate',
            columnName: 'request.study.studyDateTime',
            sorter: true,
            width: 120,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Study Description'),
            dataIndex: 'studyDescription',
            key: 'studyDescription',
            width: 190,
            render: ellipsis(190)
        },
        {
            title: t('Study Type'),
            dataIndex: 'studyType',
            key: 'studyType',
            columnName: 'request.study.studyDetail.studyType',
            sorter: true,
            width: 110,
            render: (text) => t(EnumHelper.getKeyByValue(StudyTypeEnum, text))
        },
        {
            title: 'Hbys',
            dataIndex: 'isHbysTransfer',
            key: 'isHbysTransfer',
            columnName: 'isHbysTransfer',
            sorter: true,
            width: 60,
            render: (text) => (text ? '✔' : '-')
        },
        {
            title: t('Billing Updated At'),
            dataIndex: 'billingUpdatedAt',
            key: 'billingUpdatedAt',
            width: 120,
            render: (text) => (text ? dateFormat(text) : '-')
        },
        {
            title: t('Billing Updated By'),
            dataIndex: 'billingUpdatedBy',
            key: 'billingUpdatedBy',
            width: 120,
            render: ellipsis(120)
        },
    ];
}
